var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRatingStarSemifilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11862_69839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9072 3.61746C11.1435 3.67677 11.2617 3.97328 11.0844 4.15119L8.89812 6.46399L9.31175 9.60703C9.37084 9.84424 9.07539 10.0815 8.83903 9.96285L5.88455 8.59889L2.93007 9.96285C2.69371 10.0815 2.45735 9.90355 2.45735 9.60703L2.87098 6.46399L0.802839 4.15119C0.62557 3.97328 0.684659 3.67677 0.980108 3.61746L4.11186 3.02444L5.64819 0.177908C5.76637 -0.0593027 6.12091 -0.0593027 6.23909 0.177908L7.77542 3.02444L10.9072 3.61746Z",
    fill: "#FFD02C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11862_69839)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.963923 3.61746C0.727565 3.67677 0.609385 3.97328 0.786654 4.15119L2.97297 6.46399L2.55934 9.60703C2.50025 9.84424 2.7957 10.0815 3.03206 9.96285L5.98654 8.59889L8.94103 9.96285C9.17739 10.0815 9.41374 9.90355 9.41374 9.60703L9.00012 6.46399L11.0683 4.15119C11.2455 3.97328 11.1864 3.67677 10.891 3.61746L7.75923 3.02444L6.2229 0.177908C6.10472 -0.0593027 5.75019 -0.0593027 5.63201 0.177908L4.09567 3.02444L0.963923 3.61746Z",
    fill: "#DCDCD6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11862_69839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.23333,
    height: 10,
    fill: "white",
    transform: "translate(0.703125)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11862_69839"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.23333,
    height: 10,
    fill: "white",
    transform: "matrix(-1 0 0 1 11.168 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingStarSemifilled);
export default __webpack_public_path__ + "static/media/rating_star_semifilled.618eb461803011aed8181287554acb7c.svg";
export { ForwardRef as ReactComponent };